import { AlbumSubtype, AlbumType } from "@common/admin/use-album_taxonomies";

export function getCompatibleTypes(artist: { type: string | null }, TYPES: AlbumType[]) {
  const artistType = artist.type ?? 'artist';
  const compatibleType = TYPES.filter(type => type.artist_types?.split(',').includes(artistType));
  return compatibleType;
}

export function getCompatibleSubtypes(artist: { type: string | null }, TYPES: AlbumType[], SUBTYPES: AlbumSubtype[]) {
  const compatibleTypeIds = getCompatibleTypes(artist, TYPES).map(type => type.id);
  const compatibleSubtypes = SUBTYPES.filter(sub => compatibleTypeIds.includes(sub.album_type_id));
  return compatibleSubtypes;
}
